// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/GroupsGrid/groupsGrid.css
// module id = 774
// module chunks = 1